<script>
  import Banner from '@/components/cards/Banner.vue';
  import BuyInLimitation from '@/views/app/dashboard/account/components/BuyInLimitation.vue';

  export default {
    name: 'rsg-tools',

    components: { BuyInLimitation, Banner },

    data: () => ({
      rsgItems: ['Buy Limits'],
    }),
  };
</script>

<template>
  <div class="w-full h-full d-flex justify-center align-center">
    <div class="rsg-container">
      <div class="w-full">
        <div class="text-title ml-5 mb-2">Responsible Social Gaming Tools:</div>
        <v-select
          :items="rsgItems"
          :menu-props="{
            dark: true,
            offsetY: true,
            contentClass: `menu-container`,
          }"
          class="black-input w-full"
          solo
        />
      </div>

      <hr class="divider mt-6 mb-9" />

      <banner
        class="mb-10"
        color="white"
        text="Note that you can only modify any limits that have been set after a specific period of time."
        title="No Limits Set"
      />

      <buy-in-limitation />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .rsg-container {
    width: 650px;
    margin: 75px 10px;
  }
</style>
